import { mergeMap } from 'rxjs/operators';
import { IEpic, isTypeOf } from '@cbridge-utils/redux-observable';
import { StreamAction } from '../stream.action';

export const endStreamProcessingEpic: IEpic = (action$) => action$.pipe(
  isTypeOf(
    StreamAction.create.failed,
    StreamAction.update.failed,
    StreamAction.remove.failed,
  ),
  mergeMap(() => {
    return [
      StreamAction.processing.done({}),
    ];
  }),
);
